<template>
  <div class="sale-order-list">
    <el-card shadow="always">
      <el-form
        ref="filterEl"
        size="small"
        label-width="88px"
        :model="filter"
        inline
      >
        <el-form-item prop="orderNumber" label="订单编号">
          <el-input v-model.trim="filter.orderNumber" clearable style="width: 220px" placeholder="请输入订单编号" />
        </el-form-item>
        <el-form-item prop="saleName" label="订单归属">
          <el-input v-model.trim="filter.saleName" clearable style="width: 220px" placeholder="请输入订单归属" />
        </el-form-item>
        <el-form-item prop="payTime" label="支付时间">
          <my-datePicker
            width="220px"
            ref="customDatePickerEl"
            :scopeDate="payTime"
            :timeScope="183"
            @receiveMyDate="payTimeReceiveMyDate"
          />
        </el-form-item>
        <el-form-item prop="payStatus" label="支付状态">
          <el-select style="width: 220px" v-model="filter.payStatus" placeholder="请选择" >
            <el-option label="全部" value="" />
            <el-option label="未支付" value="1" />
            <el-option label="已支付" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item prop="orderSource" label="订单类别">
          <el-select style="width: 220px" v-model="filter.orderSource" placeholder="请选择" >
            <el-option label="全部" value="" />
            <el-option label="普通订单" value="1" />
            <el-option label="团购订单" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item prop="sourceType" label="订单来源">
          <el-select style="width: 220px" v-model="filter.sourceType" placeholder="请选择订单来源" >
            <el-option label="全部" value="" />
            <el-option label="PC" value="1" />
            <el-option label="小程序" value="2" />
            <el-option label="安卓" value="3" />
            <el-option label="ios" value="4" />
            <el-option label="H5" value="5" />
            <el-option label="后台" value="6" />
          </el-select>
        </el-form-item>
        <el-form-item prop="refundStatus" label="退款状态">
          <el-select style="width: 220px" v-model="filter.refundStatus" placeholder="请选择退款状态" >
            <el-option label="全部" value="" />
            <el-option label="未退款" value="1" />
            <el-option label="退款中" value="2" />
            <el-option label="已退款" value="3" />
            <el-option label="打款失败" value="4" />
            <el-option label="已驳回" value="5" />
            <el-option label="已取消退费" value="6" />
          </el-select>
        </el-form-item>
        <el-form-item prop="phone" label="学员手机号">
          <el-input
            clearable
            style="width: 220px"
            v-model.trim="filter.phone"
            placeholder="请输入学员手机号"
          />
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearch(1)">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px">重置</el-button>
          <el-button style="margin-left: 8px" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <el-table v-loading="loading" :data="data" border>
        <el-table-column label="订单归属" minWidth="120" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.saleName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学员手机号" minWidth="160" align="center">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="班级名称" minWidth="240" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.skuName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" minWidth="260" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.orderNumber || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" minWidth="120" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.payAmt || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" minWidth="120" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.payStatus === 1">未支付</el-tag>
            <el-tag v-else-if="row.payStatus === 2" type="success">已支付</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="订单类别" minWidth="120" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.orderSource === 1">普通订单</el-tag>
            <el-tag v-else-if="row.orderSource === 2" type="success">团购订单</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="订单来源" minWidth="120" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.sourceType === 1">PC</el-tag>
            <el-tag v-else-if="row.sourceType === 2" type="success">小程序</el-tag>
            <el-tag v-else-if="row.sourceType === 3" type="info">安卓</el-tag>
            <el-tag v-else-if="row.sourceType === 4" type="danger">ios</el-tag>
            <el-tag v-else-if="row.sourceType === 5" type="warning">H5</el-tag>
            <el-tag v-else-if="row.sourceType === 6" type="warning">后台</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="退款状态" minWidth="120" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.refundStatus === 1">未退款</el-tag>
            <el-tag v-else-if="row.refundStatus === 2" type="info">退款中</el-tag>
            <el-tag v-else-if="row.refundStatus === 3" type="success">已退款</el-tag>
            <el-tag v-else-if="row.refundStatus === 4" type="danger">打款失败</el-tag>
            <el-tag v-else-if="row.refundStatus === 5" type="warning">已驳回</el-tag>
            <el-tag v-else-if="row.refundStatus === 6" type="info">已取消退费</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.payTime || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="206" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="toChangeBelong(row)">更改归属</span>
            <span class="blue_Box" @click="toBelongRecord(row)">归属更改记录</span>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>
    <!-- 更改归属 -->
    <el-dialog
      title="更改归属"
      width="680px"
      :visible.sync="dialogChangeVisible"
      :close-on-click-modal="false"
      @closed="handleCloseChange"
    >
      <el-form :model="saleFilter" label-width="88px" size="small" inline>
        <el-form-item prop="mobile" label="销售手机号">
          <el-input v-model.trim="saleFilter.mobile" style="width: 220px" clearable placeholder="请输入销售手机号" />
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearchSale(1)">查询</el-button>
          <el-button @click="handleResetSale">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="multipleTable" v-loading="loading" :data="saleData" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="销售姓名" minWidth="120" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售手机号" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.mobile || "--" }}</span>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :page-info="saleFilter"
        @handleCurrentChange="handleSaleCurrentChange"
        @handleSizeChange="handleSaleSizeChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :disabled="multipleSelection.length === 0" @click="handleChangeSale">确 定</el-button>
        <el-button size="small" @click="handleCloseChange">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 归属更改记录 -->
    <el-dialog
      title="归属更改记录"
      width="1080px"
      :visible.sync="dialogRecordVisible"
      :close-on-click-modal="false"
      @closed="handleCloseRecord"
    >
      <el-table v-loading="loading" :data="recordData" border>
        <el-table-column label="订单编号" minWidth="260" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.orderNumber || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="当前归属人" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.saleNameNow || "--" }}|{{ row.phoneNow || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="原归属人" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.saleNameOld || "--" }}|{{ row.phoneOld || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作人" minWidth="80" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.handleUserName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作时间" minWidth="158" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.handleTime || "--" }}</span>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :page-info="recordFilter"
        @handleCurrentChange="handleRecordCurrentChange"
        @handleSizeChange="handleRecordSizeChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseRecord">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 导出 -->
    <FileExport ref="FileExport" />
  </div>
</template>

<script>
import myDatePicker from "@/components/myDatePicker.vue"
import myPagination from "@/components/myPagination.vue"
import FileExport from "@/components/FileExport.vue"
import { getSaleOrderListPage, updateBaseOrderSaleId, getLogListPage } from '@/api/orderAdmin/saleOrderList.js'
import { getAppUserInfo, getTeacherList } from "@/api/common"

export default {
  name: 'SaleOrderList',

  components: {
    myPagination,
    myDatePicker,
    FileExport
  },
  data () {
    return {
      filter: {
        saleName: '',
        startDate: '',
        endDate: '',
        payStatus: '',
        orderSource: '',
        sourceType: '',
        refundStatus: '',
        phone: '',
        selfFlag: 1
      },
      payTime: [],
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0
      },
      loading: false,
      dialogChangeVisible: false,
      saleFilter: {
        page: 1,
        limit: 10,
        total: 0,
        companyFlag: 1,
        status: 1,
        userStatus: 0,
        mobile: ''
      },
      saleData: [],
      multipleSelection: [],
      targetOrderId: '',
      dialogRecordVisible: false,
      recordFilter: {
        page: 1,
        limit: 10,
        total: 0
      },
      recordData: []
    }
  },
  created () {
    this.handleSearch(1)
  },
  mounted () {
    this.$refs.customDatePickerEl.pickerKey = 1
  },
  methods: {
    handleSearch (page) {
      this.loading = true
      if (page) {
        this.pageInfo.page = page
      }
      const params = {
        ...this.pageInfo,
        ...this.filter
      }
      getSaleOrderListPage(params)
        .then(({ code, data }) => {
          this.data = data.records
          this.pageInfo.total = parseInt(data.total)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 导出
    handleExport() {
      this.$refs.FileExport.init(
        this.filter,
        'jsw-analyse-provider',
        '/adm/baseOrderData/downloadExcel',
        1,
        '销售订单数据.xlsx'
      );
    },
    toChangeBelong (row) {
      this.dialogChangeVisible = true
      this.targetOrderId = row.id
      this.handleSearchSale(1)
    },
    toBelongRecord (row) {
      this.dialogRecordVisible = true
      this.recordFilter.orderNumber = row.orderNumber
      this.recordFilter.type = 2
      this.handleSearchRecord(1)
    },
    // 重置
    handleReset() {
      this.payTime = [];
      this.filter.startDate = ''
      this.filter.endDate = ''
      this.$refs['filterEl'].resetFields()
      this.handleSearch(1)
    },
    // 支付时间
    payTimeReceiveMyDate(payload) {
      this.payTime = payload;
      this.filter.startDate = payload[0] + " 00:00:00";
      this.filter.endDate = payload[1] + " 23:59:59";
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.handleSearch(payload)
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.pageInfo.limit = payload
      this.handleSearch(1)
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.data.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    },
    // 被选中的信息 单选
    handleSelectionChange(val) {
      if (val.length > 1) {
        this.$refs.multipleTable.clearSelection()
        this.$refs.multipleTable.toggleRowSelection(val.pop())
      }
      this.multipleSelection = val
    },
    handleSearchSale (page) {
      this.loading = true
      if (page) {
        this.saleFilter.page = page
      }
      getTeacherList(this.saleFilter)
        .then(({ code, data }) => {
          if (code === 0) {
            this.saleData = data.records
            this.saleFilter.total = parseInt(data.total)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleResetSale () {
      this.saleFilter = this.$options.data().saleFilter
      this.saleData = []
      this.multipleSelection = []
      this.handleSearchSale(1)
    },
    handleChangeSale () {
      const [ sale ] = this.multipleSelection
      const params = {
        id: this.targetOrderId,
        saleId: sale.userId,
        saleName: sale.nickName
      }
      updateBaseOrderSaleId(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success('更改成功!')
          this.handleSearch()
          this.handleCloseChange()
        }
      })
    },
    // 切换页数
    handleSaleCurrentChange(payload) {
      this.handleSearchSale(payload)
    },
    // 切换每页条数
    handleSaleSizeChange(payload) {
      this.saleFilter.limit = payload
      this.handleSearchSale(1)
    },
    handleCloseChange () {
      this.saleFilter = this.$options.data().saleFilter
      this.saleData = []
      this.multipleSelection = []
      this.targetOrderId = ''
      this.$refs.multipleTable.clearSelection()
      this.dialogChangeVisible = false
    },
    handleSearchRecord (page) {
      this.loading = true
      if (page) {
        this.recordFilter.page = page
      }
      getLogListPage(this.recordFilter)
        .then(({ code, data }) => {
          if (code === 0) {
            this.recordData = data.records
            this.recordFilter.total = parseInt(data.total)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 切换页数
    handleRecordCurrentChange(payload) {
      this.handleSearchRecord(payload)
    },
    // 切换每页条数
    handleRecordSizeChange(payload) {
      this.recordFilter.limit = payload
      this.handleSearchRecord(1)
    },
    handleCloseRecord () {
      this.recordFilter = this.$options.data().recordFilter
      this.recordData = []
      this.dialogRecordVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sale-order-list {
  ::v-deep .el-table {
    .el-table__header .el-table-column--selection {
      text-align: center;
    }
    .el-table__header .el-table-column--selection .cell:before {
      content: '选择';
    }
    .el-table__header .el-table-column--selection .el-checkbox {
      display: none;
    }
  }

}
.blue_Box {
  white-space: nowrap;
  margin: 0 6px;
  color: #2d8cf0;
  cursor: pointer;
}

.blue_Box:hover {
  color: #57a3f4;
}
</style>
